<template>
  <div class="formulario h2-defaultMuni" @keyup.enter="aplicarFiltro">
    <div class="input-wrapper">
      <input v-model="nombreVecino" placeholder="Nombre del vecino" />
      <span v-if="nombreVecino" @click="nombreVecino = ''" class="clear-button">&times;</span>
    </div>
    <div class="input-wrapper">
      <input v-model="cuilVecino" placeholder="Cuil del vecino" />
      <span v-if="cuilVecino" @click="cuilVecino = ''" class="clear-button">&times;</span>
    </div>
    <div class="input-wrapper">
      <input v-model="telefonoCiDi" placeholder="Teléfono CiDi" />
      <span v-if="telefonoCiDi" @click="telefonoCiDi = ''" class="clear-button">&times;</span>
    </div>
    <div class="input-wrapper">
      <input v-model="mailCiDi" placeholder="Mail CiDi" />
      <span v-if="mailCiDi" @click="mailCiDi = ''" class="clear-button">&times;</span>
    </div>
    <div class="input-wrapper">
      <input v-model="ultimoTelefono" placeholder="Último teléfono registrado" />
      <span v-if="ultimoTelefono" @click="ultimoTelefono = ''" class="clear-button">&times;</span>
    </div>

    <div class="btnsSection">
      <button @click="aplicarFiltro" class="actionBtn h2-heroMuni"
        style="background-color: var(--color-success)">Aplicar</button>
      <button @click="limpiarFiltro" class="actionBtn h2-heroMuni"
        style="background-color: var(--color-error)">Limpiar</button>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";

const emit = defineEmits(["close-modal"]);
const store = useStore();
const router = useRouter();

const nombreVecino = ref("");
const cuilVecino = ref("");
const telefonoCiDi = ref("");
const mailCiDi = ref("");
const ultimoTelefono = ref("");

const loadFiltersFromStore = () => {
  const filters = store.state.filters['vecinos'] || {};
  nombreVecino.value = filters.firstname ?? "";
  cuilVecino.value = filters.cuil ?? "";
  telefonoCiDi.value = filters.phoneNumber ?? "";
  mailCiDi.value = filters.email ?? "";
  ultimoTelefono.value = filters.contactNumber ?? "";
};

onMounted(() => loadFiltersFromStore());

function aplicarFiltro() {
  const condiciones = {};
  if (nombreVecino.value) condiciones.firstname = nombreVecino.value;
  if (cuilVecino.value) condiciones.cuil = cuilVecino.value;
  if (telefonoCiDi.value) condiciones.phoneNumber = telefonoCiDi.value;
  if (mailCiDi.value) condiciones.email = mailCiDi.value;
  if (ultimoTelefono.value) condiciones.contactNumber = ultimoTelefono.value;

  if (Object.keys(condiciones).length === 0) return;

  if (document.activeElement) {
    document.activeElement.blur(); //quita foco del input
  }
  store.dispatch("setFiltersAction", { seccion: 'vecinos', condiciones });
  router.push({ name: "vecinos" });
  emit("close-modal");
}

function limpiarFiltro() {
  nombreVecino.value = "";
  cuilVecino.value = "";
  telefonoCiDi.value = "";
  mailCiDi.value = "";
  ultimoTelefono.value = "";
  store.dispatch("clearFiltersAction", 'vecinos');
  emit("close-modal");
}

// watch( en caso de cambios en props futuros
//   [() => props], 
//   () => {
//     loadFiltersFromStore();
//   },
//   { deep: true }
// );
</script>